import { Product } from "./products/grid/models/product";
import { Products } from "./products/grid/collections/products";
import { FilterBar } from "./products/grid/views/filter-bar";
import { Filter } from "./products/grid/models/filter";
import { ProductGrid } from "./products/grid/views/product-grid";

(function($){
    window.debuggingOn = false;
    window.debugLogger = function(){
            window.debugLog = typeof window.debugLog === 'undefined' ? [] : window.debugLog;
            let c = []
            for ( var i = 0; i < arguments.length; i++ ) {
               c.push( arguments[i]  );
                if ( window.debuggingOn ) {
                    console.log( arguments[i] ); // eslint-disable-line no-console
                }
            }
            window.debugLog.push( c );
    };
    window.debugLogger(window.filter_set_data);
    if ( $( '.product-grid-wrap' ).length ) {

        var gridElement = $( '.product-grid-wrap' );

        let productList = new Products();
        let filter = new Filter();

        var x = Object.keys( window.filter_set_data );
        for ( var y = 0; y < x.length; y++ ) {
            var k = x[y];
            filter.register_filter_option( window.filter_set_data[k] );
        }

        // for each products in the grid, add it to our collection
        $( '.product-card', gridElement ).each( function(){
            var productFilters = JSON.parse( this.dataset.filters );

            var t = Object.keys( productFilters );
            for ( var i = 0; i < t.length; i++ ) {
                var key = t[i];
                var term = productFilters[key];
                if ( !_.isNull( term ) ) {
                    
                    if ( _.isArray( term ) ) {
                        // add each of them
                        for ( var a = 0; a < term.length; a++ ) {
                            filter.register_filter_term( term[a], key );
                        }
                    } else {
                        filter.register_filter_term( term, key );
                    }
                }
            }
            // this.dataset[filter] = filter;
            // console.log(this.dataset);
            var product = new Product(this.dataset);
            productList.add( product ); 

            
        });
        // productList.sort();
        // all products are loaded, update the filter with a default state
        // filter.defaultState();
        window.debugLogger( filter.get('filter_options').toJSON() );
        
        let filterBar = new FilterBar({ model: filter, collection: productList });
        gridElement.prepend( filterBar.el );

        window.filter_bar = filterBar;
        window.productList = productList;
        // once the collection is complete, spin up the backbone view for the grid.
        let grid = new ProductGrid({ 'el': gridElement, 'collection': productList, 'filter' : filter });
        grid.render();

        // var lastFilter = {};
        var hashFiltering = function(){
            $( window ).off( 'popstate', hashFiltering );
            window.grcCloseNav();
            var settingsObj = {};
            let settings = window.location.hash.length ? window.location.hash.substr(2).split( '/' ) : '';
            var option, key, val;
            for ( var i = 0; i < settings.length; i++ ){
			    option = settings[i].split(':');
                if ( option.length == 2 ) {
                    key = option[0];
                    val = option[1];
                    switch ( key ) {
                        case 'orderby':
                        case 'order':
                            // do something with order or orderby? for now ignore...
                            break; 
                        default:
                            settingsObj[key] = val == 'true' ? true : decodeURI( val );
                            break;
                    }
                }
            }


            // console.log( settingsObj ); 
            // call into filter with hash settings.
            // if ( Object.keys(settingsObj).length ) {
                filter.updateFilterFromHash( settingsObj );
            // }

            $( window ).on( 'popstate', hashFiltering );
        };

        $( window ).on( 'popstate', hashFiltering );
    }
})(jQuery);